import { NetworkBasePopUp } from '../NetworkBasePopUp';

export class InstallAgentPopUp extends NetworkBasePopUp<undefined> {
  protected title = ''; // not used
  protected extraDialogConfigs = {}; // not used
  protected async handleConfirmButtonClicked(event: CustomEvent) {} // not used

  protected customSetup() {
    const controller = app.getController('Application.modules.network.controller.endpoints.deploy.controller');
    controller.externalTargets = this.data.targets;
    controller.customCreationSuccessNotification = () => this.showTaskCreatedToast();
    controller.customCreationFailureNotification = (message: string) => this.showErrorToastNotification(message);
    controller.createInstallAgentTaskPanel();
  }
}
